import { AnnotationBase } from '../../common/annotation/annotation';
import { appendElement, redrawElement } from '../../common/utils/helper';
import { createElement } from '@syncfusion/ej2-base';
/**
 * `AccumulationAnnotation` module handles the annotation for accumulation chart.
 */
export class AccumulationAnnotation extends AnnotationBase {
    /**
     * Constructor for accumulation chart annotation.
     *
     * @private
     * @param {AccumulationChart} control - The accumulation chart control.
     */
    constructor(control) {
        super(control);
        this.pie = control;
    }
    /**
     * Method to render the annotation for accumulation chart.
     *
     * @param {Element} element - Annotation element.
     * @returns {void}
     * @private
     */
    renderAnnotations(element) {
        this.annotations = this.pie.annotations;
        const redraw = this.pie.redraw;
        this.parentElement = (redrawElement(redraw, this.pie.element.id + '_Annotation_Collections') ||
            createElement('div', {
                id: this.pie.element.id + '_Annotation_Collections'
            }));
        this.annotations.map((annotation, index) => {
            this.processAnnotation(annotation, index, this.parentElement);
        });
        if (this.pie.series[0].animation.enable && this.pie.series[0].type === 'Pie' && this.pie.animateSeries) {
            this.parentElement.style.visibility = 'hidden';
        }
        appendElement(this.parentElement, element, redraw);
    }
    /**
     * Get module name.
     *
     * @returns {string} - Returns the module name.
     */
    getModuleName() {
        // Returns te module name
        return 'Annotation';
    }
    /**
     * To destroy the annotation.
     *
     * @returns {void}
     *
     * @private
     */
    destroy() {
        // Destroy method performed here
    }
}
